import axios from '../api/axios';

export const getBanners = () => axios.get('/banner');
export const getBanner = (id) => axios.get(`/banner/${id}`);
export const createBanner = (data) => axios.post('/banner', data);
export const updateBanner = (id, data) => axios.put(`/banner/${id}`, data);
export const deleteBanner = (id) => axios.delete(`/banner/${id}`);
